module.exports = __webpack_public_path__ + "static/media/airbrake-snow-poster.ddced3de.png";


//////////////////
// WEBPACK FOOTER
// ./src/screens/switchlock/airbrake-snow-poster.png
// module id = 3497
// module chunks = 0